import { useEffect, useRef } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Wie kann ich einen Termin buchen?",
    a: "Du kannst deinen Wunschtermin ganz einfach online über Planity buchen – 24/7, schnell und unkompliziert. Alternativ erreichst du uns telefonisch unter +49 151 7253 0302 oder per E-Mail an info@22studios.de.",
  },
  {
    q: "Muss ich eine Anzahlung leisten?",
    a: "Nein, bei 22 Studios ist keine Anzahlung nötig. Du bezahlst erst nach deiner Behandlung direkt im Studio – bar oder mit Karte.",
  },
  {
    q: "Welche Produkte werden verwendet?",
    a: "Wir arbeiten ausschließlich mit hochwertigen Marken: Paul Mitchell für Haarbehandlungen, iS Clinical für Gesichtsbehandlungen und Glow Solution für Aquafacial-Treatments. So garantieren wir beste Ergebnisse.",
  },
  {
    q: "Wie lange hält ein Lash Lifting?",
    a: "Ein Lash Lifting hält in der Regel 6–8 Wochen, abhängig vom natürlichen Wimpernwachstumszyklus. Die Behandlung dauert ca. 45–60 Minuten und verleiht deinen Naturwimpern einen schönen, geschwungenen Look – ganz ohne Extensions.",
  },
  {
    q: "Ist die dauerhafte Haarentfernung schmerzhaft?",
    a: "Dank der integrierten –26°C Kühlung des ALIX Secret Twin Geräts ist die Diodenlaser-Behandlung sehr schmerzarm. Die meisten Kunden empfinden nur ein leichtes Wärmegefühl. Die Technologie ist für alle Hauttypen geeignet.",
  },
  {
    q: "Wie oft muss ich zur dauerhaften Haarentfernung kommen?",
    a: "Für optimale Ergebnisse empfehlen wir 6–8 Sitzungen im Abstand von 4–6 Wochen. Bereits nach den ersten Sitzungen wirst du eine deutliche Reduzierung des Haarwuchses bemerken.",
  },
  {
    q: "Kann ich meinen Termin stornieren oder verschieben?",
    a: "Ja, Termine können bis zu 24 Stunden vorher kostenfrei über Planity verschoben oder storniert werden. Bei kurzfristigeren Absagen bitten wir um telefonische Kontaktaufnahme.",
  },
  {
    q: "Wo befindet sich das Studio und gibt es Parkplätze?",
    a: "22 Studios befindet sich in der Deidesheimer Str. 4, 90469 Nürnberg. Parkplätze sind direkt in der Umgebung vorhanden. Öffnungszeiten: Di–Mi 9–18 Uhr, Do–Fr 10–20 Uhr, Sa 9–16 Uhr.",
  },
];

const FAQ = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".animate-on-scroll");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="faq" className="py-16 md:py-24 relative z-10">
      <div className="container px-6">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 animate-on-scroll opacity-0 translate-y-8">
            <div className="inline-block px-8 py-5 rounded-2xl bg-foreground/5 backdrop-blur-md border border-foreground/10">
              <div className="flex items-center justify-center gap-4 mb-3">
                <span className="w-12 h-px bg-gradient-to-r from-transparent to-highlight" />
                <span className="text-sm tracking-wide uppercase text-label font-medium">Häufige Fragen</span>
                <span className="w-12 h-px bg-gradient-to-l from-transparent to-highlight" />
              </div>
              <h2 className="text-heading md:text-display font-serif font-light text-foreground">
                Alles rund um <span className="text-highlight font-medium">22 Studios</span>
              </h2>
            </div>
            <p className="mt-5 text-muted-foreground font-light">
              Die wichtigsten Fragen und Antworten zu unserem Beautystudio in Nürnberg
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="animate-on-scroll opacity-0 translate-y-8">
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="bg-background border border-border rounded-2xl px-6 overflow-hidden data-[state=open]:shadow-md transition-shadow"
                >
                  <AccordionTrigger className="text-left font-medium text-foreground hover:no-underline py-5 text-base">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground font-light leading-relaxed pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
